import 'element-plus/theme-chalk/base.css';
//# sourceMappingURL=css.mjs.map
